import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import ZebraCarsLanding from "@/components/layout/ZebraCarsLanding";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ZebraCarsLanding />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
